module.exports = __webpack_public_path__ + "images/fa-lf-banner-extend-block.webp";